import { DatePicker } from "antd";
import moment from "moment-timezone";

import { CustomDateRange } from "api/generated/model";

import * as theme from "./CustomRangePicker.css";

interface CustomRangePickerProps {
    value: CustomDateRange;
    onChange: (value: CustomDateRange) => void;
}

const { RangePicker } = DatePicker;

/** The `YYYY-MM-DD` range picker behind every "Custom" date range preset. */
export function CustomRangePicker({ value, onChange }: CustomRangePickerProps) {
    const dates: [moment.Moment | null, moment.Moment | null] = [
        value.startDate ? moment(value.startDate) : null,
        value.endDate ? moment(value.endDate) : null,
    ];

    return (
        <RangePicker
            format="DD-MM-YYYY"
            onChange={(nextRange) =>
                onChange({
                    startDate: nextRange?.[0]?.format("YYYY-MM-DD") ?? null,
                    endDate: nextRange?.[1]?.format("YYYY-MM-DD") ?? null,
                })
            }
            value={dates}
            allowEmpty={[true, true]}
            showNow
            autoFocus
            className={theme.rangePicker}
        />
    );
}
